<vectronic-card
  [title]="'Add Frequency'"
  [displayClose]="true"
  (closed)="dialogRef.close()"
  class="add-frequency"
>
  <ng-container body>
    <form [formGroup]="formGroup">
      <mat-form-field appearance="outline" class="add-frequency__field">
        <mat-label>Number of frequencies</mat-label>
        <input
          type="number"
          pattern="\d*"
          matInput
          formControlName="devicesAmount"
          [errorStateMatcher]="matcher"
          min="1"
        />
        <mat-error> It should be between 1 and {{ data.devicesAmount }} </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="add-frequency__field">
        <mat-label>Start frequency</mat-label>
        <input
          type="number"
          matInput
          formControlName="startFrequency"
          [errorStateMatcher]="matcher"
          min="135"
          max="234"
          step="0.01"
        />
        <span matSuffix>MHz</span>
        <mat-error>It should be between 135.000 to 234.000</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Steps</mat-label>
        <input
          type="number"
          matInput
          formControlName="step"
          step="0.01"
          min="0.01"
          max="0.99"
          [errorStateMatcher]="matcher"
        />
        <span matSuffix>MHz</span>
        @if (formGroup.get('step').hasError('min') || formGroup.get('step').hasError('max')) {
          <mat-error>It should be between 0.01 to 0.99</mat-error>
        } @else if (formGroup.get('step').hasError('pattern')) {
          <mat-error>It should be a number with up to two decimal places</mat-error>
        }
      </mat-form-field>
      <div class="add-frequency__action-button">
        <button mat-button [mat-dialog-close]="false">
          <mat-icon color="warn">cancel</mat-icon>
          Cancel
        </button>
        <button
          class="add-frequency__action-button-send"
          mat-button
          (click)="onClickSendFrequency()"
          [disabled]="formGroup.invalid"
        >
          <mat-icon color="accent">check_circle</mat-icon>
          Confirm
        </button>
      </div>
    </form>
  </ng-container>
</vectronic-card>
